export default __webpack_public_path__ + "static/media/gd-report.df1d6032.pdf";